module.exports = __webpack_public_path__ + "static/media/hktdc_logo.bdbc11a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hktdc_logo.png
// module id = 668
// module chunks = 0